<form
  [formGroup]="formTipoServico"
  class="n-form-tipos-servico"
  (ngSubmit)="salvar()"
  (keydown.enter)="onEnter($event)"
>
  <div class="n-container-orientacoes">
    <h4 class="n-titulo-orientacao">{{ 'PRIMEIRO_ACESSO.TIPOS_SERVICO.ORIENTACAO_TITULO' | translate }}</h4>
    <p [innerHTML]="'PRIMEIRO_ACESSO.TIPOS_SERVICO.ORIENTACAO_TEXTO' | translate"></p>
  </div>

  <div class="n-form-center">
    <div class="n-tipo-servico-input">
      <lib-form-field
        [label]="'PRIMEIRO_ACESSO.TIPOS_SERVICO.LABEL_NOME' | translate"
        controlName="novoTipo"
      >
        <div class="n-input-action">
          <input
            pInputText
            id="novoTipo"
            formControlName="novoTipo"
            [placeholder]="'PRIMEIRO_ACESSO.TIPOS_SERVICO.PLACEHOLDER_NOME' | translate"
            (blur)="onBlur()"
          />
          <p-button
            icon="pi pi-plus"
            (onClick)="adicionarTipo()"
            styleClass="n-button-sec"
            [loading]="salvando"
            type="button"
            size="small"
            [disabled]="!formTipoServico.get('novoTipo')?.value?.trim()"
          />
        </div>
      </lib-form-field>
      <small class="n-field-hint">
        <i class="pi pi-lightbulb"></i>
        {{ 'PRIMEIRO_ACESSO.TIPOS_SERVICO.HINT' | translate }}
      </small>
    </div>

    @if (temTipos) {
    <div class="n-chips-container">
      <h5>{{ 'PRIMEIRO_ACESSO.TIPOS_SERVICO.CATEGORIAS_ADICIONADAS' | translate }}</h5>
      <div class="n-chips-list">
        @for (tipo of tiposServicosSignal(); track tipo) {
        <p-chip
          [label]="tipo"
          [removable]="true"
          (onRemove)="removerTipo(tipo)"
          styleClass="n-chip"
        />
        }
      </div>
    </div>
    } @else {
    <div class="n-empty-state">
      <i class="pi pi-inbox"></i>
      <p>{{ 'PRIMEIRO_ACESSO.TIPOS_SERVICO.EMPTY_TITULO' | translate }}</p>
      <small>{{ 'PRIMEIRO_ACESSO.TIPOS_SERVICO.EMPTY_SUBTITULO' | translate }}</small>
    </div>
  }
  </div>

</form>

<ng-template #headerTemplate>
  <div class="w-full">
    <div
      class="pr-1 pl-1 pb-2 pt-2 border-round-lg lg:col-12 n-header-gradient"
    >
      <div class="n-header-content">
        <div class="sm:col-12 md:col-8">
          <span class="n-header-title text-white font-bold">
            <i class="pi pi-tags mr-2"></i>
            {{ 'PRIMEIRO_ACESSO.TIPOS_SERVICO.HEADER_TITULO' | translate }}
          </span>
        </div>
        <div class="sm:col-12 md:col-4 flex justify-content-end gap-2">
          @if (!deviceService.$isMobile()) {
          <button
            type="button"
            class="n-close-btn"
            (click)="fechar.emit()"
            [attr.aria-label]="'GLOBAL.FECHAR' | translate"
          >
            <i class="pi pi-times"></i>
          </button>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex gap-2 justify-content-end w-full">
    <p-button
      type="button"
      [label]="'GLOBAL.PROXIMO' | translate"
      icon="pi pi-arrow-right"
      iconPos="right"
      styleClass="p-button-primary w-full"
      [loading]="salvando"
      [disabled]="!temTipos || salvando"
      (onClick)="salvar()"
    />
  </div>
</ng-template>
